import React, { useMemo } from "react";

const EpRecipientsStats = ({ recipients }) => {
  const stats = useMemo(() => {
    const total = recipients.length;
    const suspensions = recipients.filter((r) => r.type === "SUSPENSION").length;
    const suppressions = total - suspensions;

    const premier = recipients.filter(
      (r) => r.detectionType === "PREMIER",
    ).length;
    const persistance = recipients.filter(
      (r) => r.detectionType === "PERSISTANCE",
    ).length;
    const reiteration = recipients.filter(
      (r) => r.detectionType === "REITERATION",
    ).length;

    const withHistory = recipients.filter(
      (r) => r.epHistory && r.epHistory.length > 0,
    ).length;

    const pregnancies = recipients.filter((r) => r.pregnancy).length;

    const over62 = recipients.filter(
      (r) =>
        r.userRecipient?.age && parseInt(r.userRecipient.age) > 62,
    ).length;

    const withSecondaryReasons = recipients.filter(
      (r) => r.secondaryReasons && r.secondaryReasons.length > 0,
    ).length;

    return {
      total,
      suspensions,
      suppressions,
      premier,
      persistance,
      reiteration,
      withHistory,
      pregnancies,
      over62,
      withSecondaryReasons,
    };
  }, [recipients]);

  if (stats.total === 0) return null;

  const counters = [
    {
      label: "Suspensions",
      value: stats.suspensions,
      icon: "fa-pause-circle",
      bg: "#fef3c7",
      color: "#92400e",
      show: true,
    },
    {
      label: "Suppressions",
      value: stats.suppressions,
      icon: "fa-times-circle",
      bg: "#fee2e2",
      color: "#991b1b",
      show: true,
    },
    {
      label: "1er manquement",
      value: stats.premier,
      icon: "fa-info-circle",
      bg: "#dbeafe",
      color: "#1e40af",
      show: stats.premier > 0,
    },
    {
      label: "Persistance",
      value: stats.persistance,
      icon: "fa-refresh",
      bg: "#fef3c7",
      color: "#92400e",
      show: stats.persistance > 0,
    },
    {
      label: "Réitération",
      value: stats.reiteration,
      icon: "fa-repeat",
      bg: "#fee2e2",
      color: "#991b1b",
      show: stats.reiteration > 0,
    },
    {
      label: "Avec antécédents",
      value: stats.withHistory,
      icon: "fa-history",
      bg: "#fffbeb",
      color: "#78350f",
      show: stats.withHistory > 0,
    },
    {
      label: "Motifs de modération",
      value: stats.withSecondaryReasons,
      icon: "fa-balance-scale",
      bg: "#f3e8ff",
      color: "#6b21a8",
      show: stats.withSecondaryReasons > 0,
    },
    {
      label: "Grossesse",
      value: stats.pregnancies,
      icon: "fa-heart",
      bg: "#fce7f3",
      color: "#9d174d",
      show: stats.pregnancies > 0,
    },
    {
      label: "+62 ans",
      value: stats.over62,
      icon: "fa-exclamation-triangle",
      bg: "#fef3c7",
      color: "#92400e",
      show: stats.over62 > 0,
    },
  ];

  const visibleCounters = counters.filter((c) => c.show);

  return (
    <div
      className="d-flex flex-wrap mb-3"
      style={{ gap: 8 }}
    >
      {visibleCounters.map((counter) => (
        <div
          key={counter.label}
          className="d-flex align-items-center px-2 py-1 rounded"
          style={{
            background: counter.bg,
            gap: 6,
          }}
        >
          <i
            className={`fa ${counter.icon}`}
            style={{ fontSize: 11, color: counter.color }}
          />
          <span
            style={{
              fontSize: 12,
              fontWeight: 700,
              color: counter.color,
            }}
          >
            {counter.value}
          </span>
          <span
            style={{
              fontSize: 11,
              color: counter.color,
              opacity: 0.85,
            }}
          >
            {counter.label}
          </span>
        </div>
      ))}
    </div>
  );
};

export default EpRecipientsStats;
